export enum ModuleEnum {
  'HOME' = 'HOME', // 首页
  'COURSE' = 'COURSE', // 资源中心的路由
  'LIVE' = 'LIVE', // 直播的路由
  'EXAM' = 'EXAM', // 学考中心的路由
  'TRAIN' = 'TRAIN', // 培训中心的路由
  'INFO' = 'INFO', // 资讯中心的路由
  'KNOWLEDGE' = 'KNOWLEDGE', // 文库
  'PROFESSOR' = 'PROFESSOR', // 教官中心的路由
  'PERSONAL' = 'PERSONAL', // 个人中心的路由
  'IKNOW' = 'IKNOW', // 知圈
  'SHORTVIDEO' = 'SHORTVIDEO', // 短视频
}

export const ResourceMap = {
  // '回放'
  // zn-i18n-disable-next-line
  livePlayback: { title: '回放', type: 'playback' },
  33: { title: '回放', type: 'playback' },
  // '直播'
  // zn-i18n-disable-next-line
  live: { title: '直播', type: 'live' },
  31: { title: '直播', type: 'live' },
}

/**
 * @description 此枚举为单点登录资源列表路径映射
 */
export enum ResourceTypeEnum {
  studyMap = '/home/studyMapList/0', // 默认未学
  training = '/home/trainingClass',
  live = '/home/livelist/1', // 直播
  livePlayback = '/home/livelist/2', // 直播回放
  course = '/home/course',
  myCourse = '/home/myCourse',
  myExam = '/home/myExam',
  publicExam = '/home/publicExam',
  myTraining = '/home/myTrainingClass',
  myQuestionnaire = '/home/myQuestionnaire',
  coursePlay = '/coursePlay/:resourceId',
  myWork = '/home/myWork',
  shortPlay = '/home/liteVideo',
  searchPage = '/home/search',
}

/**
 * @description 此枚举描述一个需要特殊处理的资源值
 */
export enum OtherTypeEnum {
  LIVE = 'live',
  LIVE_PLAY_BACK = 'livePlayback',
  EXAM = 'myExam',
  COURSE_PLAY = 'coursePlay',
  SHORT_PLAY = 'shortPlay',
  SEARCH_PAGE = 'searchPage',
  COURSE = 'course'
}

/**
 * @description 此枚举为单点登录资源详情路由方法映射，枚举值对应[RouterUtil]对象中对应的方法
 */
export enum ResourceIdEnum {
  studyMap = 'toSelfStudyMap',
  training = 'toSelfTrainingClass',
  course = 'toSelfCourse',
  myCourse = 'toSelfCourse',
  myTraining = 'toSelfTrainingClass',
  myQuestionnaire = 'toSelfQuestionnaire',
  myWork = 'toHomeWork',
  info = 'toInformation',
  live = 'toSelfLive',
  exam = 'toExam',
}

/**
 * @description 此枚举为对标插件的单点登录
 */
export const ResourceTypeNumber = {
  56: ResourceIdEnum.studyMap,
  4: ResourceIdEnum.training,
  0: ResourceIdEnum.course,
  57: ResourceIdEnum.myQuestionnaire,
  66: ResourceIdEnum.myWork,
  22: ResourceIdEnum.training,
  31: ResourceIdEnum.live,
  33: ResourceIdEnum.live,
  37: ResourceIdEnum.exam,
  30: ResourceIdEnum.exam,
  126: ResourceTypeEnum['shortPlay'],
  23: ResourceTypeEnum['myQuestionnaire'],
  28: ResourceTypeEnum['live'],
  1: ResourceIdEnum.info,
}

export enum ResourceTypeEnum {
  LIVE_PLAY_BACK = '33',
  LIVE = '31',
  SHORT_PLAY = '126',
  COURSE = '0',
  EXAM = '30',
}
